import 'xe-utils';
import Fragment from 'vue-fragment';
import Vue from 'vue';
// Fragment
Vue.use(Fragment.Plugin);
